var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAirGreenland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.298,
    height: 26.286,
    viewBox: "0 0 26.298 26.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-188{fill:#fff;fill-rule:evenodd}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LogoAirGreenland",
    transform: "translate(-71.605 -.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    d: "M248.546 102.543a.933.933 0 1 1-.933-.933.933.933 0 0 1 .933.933",
    className: "cls-188",
    transform: "translate(-167.999 -80.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    d: "M248.546 80.4a.933.933 0 1 1-.933-.927.933.933 0 0 1 .933.927",
    className: "cls-188",
    transform: "translate(-167.999 -72.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    d: "M242.014 101.41a1.054 1.054 0 1 1-1.054 1.054 1.054 1.054 0 0 1 1.054-1.054",
    className: "cls-188",
    transform: "translate(-165.744 -80.821)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    d: "M242.093 96.09a.927.927 0 1 1-.933.927.927.927 0 0 1 .933-.927",
    className: "cls-188",
    transform: "translate(-165.823 -78.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    d: "M264.2 96.09a.927.927 0 1 1-.927.927.927.927 0 0 1 .927-.927",
    className: "cls-188",
    transform: "translate(-174.539 -78.724)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    d: "M242.172 90.77a.8.8 0 1 1-.572.23.806.806 0 0 1 .575-.232",
    className: "cls-188",
    transform: "translate(-165.902 -76.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    d: "M246.89 97.1a.806.806 0 1 0 .806-.806.806.806 0 0 0-.806.806",
    className: "cls-188",
    transform: "translate(-168.082 -78.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    d: "M258 97.1a.806.806 0 1 0 .806-.806.806.806 0 0 0-.806.806",
    className: "cls-188",
    transform: "translate(-172.461 -78.803)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    d: "M246.89 86.046a.806.806 0 1 0 .806-.806.806.806 0 0 0-.806.806",
    className: "cls-188",
    transform: "translate(-168.082 -74.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    d: "M258 86.046a.806.806 0 1 0 .806-.806.806.806 0 0 0-.806.806",
    className: "cls-188",
    transform: "translate(-172.461 -74.447)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    d: "M248.461 91.686a.685.685 0 1 0-.321.646.685.685 0 0 0 .321-.646",
    className: "cls-188",
    transform: "translate(-168.162 -76.744)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    d: "M235 107.826a1.3 1.3 0 1 0 1.3-1.3 1.3 1.3 0 0 0-1.3 1.3",
    className: "cls-188",
    transform: "translate(-163.395 -82.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    d: "M235 96.772a1.3 1.3 0 1 0 .378-.921 1.3 1.3 0 0 0-.378.921",
    className: "cls-188",
    transform: "translate(-163.395 -78.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    d: "M235 85.722a1.3 1.3 0 1 0 1.3-1.3 1.3 1.3 0 0 0-1.3 1.3",
    className: "cls-188",
    transform: "translate(-163.395 -74.124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    d: "M246.08 107.826a1.3 1.3 0 1 0 1.3-1.3 1.3 1.3 0 0 0-1.3 1.3",
    className: "cls-188",
    transform: "translate(-167.762 -82.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    d: "M257.13 107.826a1.3 1.3 0 1 0 1.3-1.3 1.3 1.3 0 0 0-1.3 1.3",
    className: "cls-188",
    transform: "translate(-172.118 -82.839)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    d: "M254.031 102.626a.806.806 0 1 1-.806-.806.806.806 0 0 1 .806.806",
    className: "cls-188",
    transform: "translate(-170.262 -80.983)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    d: "M253.981 97.133a.685.685 0 1 1-.321-.646.685.685 0 0 1 .321.646",
    className: "cls-188",
    transform: "translate(-170.338 -78.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    fill: "#fff",
    d: "M253.945 91.727a.557.557 0 1 0-.557.557.557.557 0 0 0 .557-.557",
    transform: "translate(-170.423 -76.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    d: "M248.628 74.834a1.054 1.054 0 1 0-1.054 1.054 1.054 1.054 0 0 0 1.054-1.054",
    className: "cls-188",
    transform: "translate(-167.936 -69.929)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    d: "M248.633 69.227a1.175 1.175 0 1 0-.346.833 1.181 1.181 0 0 0 .346-.833",
    className: "cls-188",
    transform: "translate(-167.837 -67.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    d: "M268.59 96.934a1.054 1.054 0 1 0 1.054-1.054 1.054 1.054 0 0 0-1.054 1.054",
    className: "cls-188",
    transform: "translate(-176.636 -78.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    d: "M276.263 96.851a1.175 1.175 0 1 0-.344.837 1.181 1.181 0 0 0 .344-.837",
    className: "cls-188",
    transform: "translate(-178.729 -78.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    d: "M265.168 80.314a1.054 1.054 0 1 1-1.054-1.054 1.054 1.054 0 0 1 1.054 1.054",
    className: "cls-188",
    transform: "translate(-174.456 -72.089)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    d: "M270.785 74.672a1.3 1.3 0 1 1-1.3-1.3 1.3 1.3 0 0 1 1.3 1.3",
    className: "cls-188",
    transform: "translate(-176.474 -69.768)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    d: "M276.392 68.991a1.551 1.551 0 1 1-1.551-1.551 1.551 1.551 0 0 1 1.551 1.551",
    className: "cls-188",
    transform: "translate(-178.489 -67.43)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAirGreenland);
export default __webpack_public_path__ + "static/media/LogoAirGreenland.f02215b921bd673fe2b9dbf1830b1bf5.svg";
export { ForwardRef as ReactComponent };